import React, { useState, lazy, Suspense } from 'react';
import cn from 'classnames';
import ImageLink from './ImageLink';
import { useHeaderRndVideos } from 'staticQueries/header-rnd-videos';
import { useStateModal } from 'utils/hooks';
import { pushHeaderEvent } from '../../../utils';
import * as styles from './TabsWithLinks.module.scss';

const PlayerModal = lazy(() => import('components/Modals/PlayerModal'));

export default function ArticleCards() {
  const videos = useHeaderRndVideos();
  const { modalState, showModal, hideModal } = useStateModal();
  const [videoSrc, setVideoSrc] = useState(null);

  const openModal = (videoId, title, e) => {
    setVideoSrc(videoId);
    showModal(e);
    pushHeaderEvent('click_on_insight_card', title, 'Desktop');
  };

  const handleKeyDown = (videoId, title, e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      openModal(videoId, title, e);
      e.preventDefault();
    }
  };

  return (
    <div className={cn(styles.linksWrap, styles.imagesWrap)}>
      {videos?.map(({ title, cover, videoId }, i) => {
        return (
          <ImageLink
            key={`video-${i}`}
            title={title}
            img={{ desktop: cover.url }}
            tabIndex={0}
            onClick={e => openModal(videoId, title, e)}
            onKeyDown={e => handleKeyDown(videoId, title, e)}
          />
        );
      })}
      <Suspense fallback={null}>
        <PlayerModal
          isOpen={modalState.isOpen}
          closeModalCallback={hideModal}
          data={{ videoSrc }}
        />
      </Suspense>
    </div>
  );
}
